import React from "react";
import FeedBackLayout from "../pages/feedback/FeedBackLayout";

const FeedBack = () => {
    return <FeedBackLayout />;
};

export default FeedBack;
